import React from 'react';
import Projects from '../containers/Reviews/Review';

const ProjectsPage = () => {
  return (
    <div>
      <Projects />
    </div>
  );
};
  
export default ProjectsPage;